






































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Room } from '@/class/room'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'
import InputText from '@/components/Utils/form/text/InputText.vue'
import Checkbox from '@/components/Utils/form/checkbox/Checkbox.vue'
import HeadlineDot from '@/components/Utils/headline/HeadlineDot.vue'

@Component({
  components: {
    BtnSquare,
    InputText,
    Checkbox,
    HeadlineDot
  }
})
export default class OtherSettings extends Vue {
  @Prop() room!: Room;

  updateRoom () {
    this.room.updateRoom()
  }
}
